import { useState } from 'react';
import api from '../api/client';
import Modal from './Modal';

/** Кнопка: вставить ссылку на занятие и отправить ученику (email / Max). */
export default function SendLessonLinkButton({ studentId, studentName }) {
  const [open, setOpen] = useState(false);
  const [meetingUrl, setMeetingUrl] = useState('');
  const [whenLabel, setWhenLabel] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');

  async function handleSend(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    setOk('');
    try {
      await api.post(`/messaging/teacher/students/${studentId}/send-lesson-link/`, {
        meeting_url: meetingUrl.trim(),
        when_label: whenLabel.trim(),
        message: message.trim(),
      });
      setOk('Отправлено');
      setMeetingUrl('');
      setMessage('');
      setTimeout(() => {
        setOpen(false);
        setOk('');
      }, 800);
    } catch (err) {
      setError(
        err.response?.data?.detail
        || err.response?.data?.meeting_url
        || 'Не удалось отправить',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline"
        onClick={() => {
          setError('');
          setOk('');
          setOpen(true);
        }}
      >
        Ссылка на занятие
      </button>
      <Modal
        open={open}
        title={`Ссылка для ${studentName || 'ученика'}`}
        onClose={() => !busy && setOpen(false)}
      >
        <form onSubmit={handleSend} className="ops-form">
          <p className="muted" style={{ marginTop: 0 }}>
            Вставьте ссылку Телемоста / Zoom / Max-звонка. Ученик получит её на email
            (или в бот Макс, если канал Макс и chat_id привязан).
          </p>
          <label className="form-label">
            Ссылка
            <input
              className="form-input"
              type="url"
              required
              placeholder="https://…"
              value={meetingUrl}
              onChange={(e) => setMeetingUrl(e.target.value)}
            />
          </label>
          <label className="form-label">
            Когда (необязательно)
            <input
              className="form-input"
              type="text"
              placeholder="сегодня в 16:00"
              value={whenLabel}
              onChange={(e) => setWhenLabel(e.target.value)}
            />
          </label>
          <label className="form-label">
            Комментарий
            <textarea
              className="form-input"
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>
          {error && <div className="alert alert-error">{error}</div>}
          {ok && <div className="alert alert-success">{ok}</div>}
          <div className="ops-form-actions">
            <button type="button" className="btn btn-outline" disabled={busy} onClick={() => setOpen(false)}>
              Отмена
            </button>
            <button type="submit" className="btn btn-primary" disabled={busy || !meetingUrl.trim()}>
              {busy ? 'Отправка…' : 'Отправить'}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
